export const ROLE_MUTATION = `
mutation() {
  role() {
  }
}

`
